export default __webpack_public_path__ + "images/je-7a0b4850d933dbc21d7544b015d878b7.svg";